<template>
  <div style="color: #000 !important;">
    <h3>{{
      langName == "ar" ? `حدد العنصر البديل` : `Select Alternative Item`
    }}</h3>
    <div class="row fnb-item-list">
      <div
        class="py-1 col-5"
        v-for="(dataItems, index) in getFilteredAlterNativeFnbItems[0].items"
        :key="index"
      >
        <!-- v-for="(dataItems, index) in Item.items"
          :key="index" -->
        <div
          class="fnb-card"
          :title="dataItems.Description"
          style="border: 1px solid #000 !important;padding: 10px"
        >
          <div class="fnb-img d-flex justify-content-center">
            <img
              v-if="dataItems.ThumbnailImage"
              :src="dataItems.ThumbnailImage"
              class="image img-fluid"
              alt=""
            />
            <img
              v-else
              src="@/assets/img/dummy_img.png"
              class="image img-fluid"
            />
          </div>
          <div class="fnb-content pt-2">
            <p
              class="main-title ar-number"
              :style="
                langName == `ar` && dataItems.alternate_item_name
                  ? 'text-align:end'
                  : ''
              "
            >
              {{
                langName == "ar"
                  ? dataItems.alternate_item_name
                  : dataItems.alternate_item_name
                  ? dataItems.ItemName
                  : dataItems.ItemName
              }}
              <!-- &nbsp;{{
                            dataItems.FnbDetail.is_premier_item
                          }}
                          &nbsp;{{ dataItems.Qty }} -->
            </p>
            <div class="grid-half-new">
              <div class="fnb-amt ar-number" style="color: #000 !important;">
                {{ dataItems.Currency }}
                {{ currFormat(dataItems.Amount) }}
              </div>
              <div class="combo_qty" style="gap:0px !important">
                <div
                  class="combo_icon"
                  @click="
                    storeAlternateFnbItems(
                      dataItems,
                      'sub',
                      dataItems.fnbItemDataIndex,
                      dataItems.fnbItemDataItemsIndex
                    )
                  "
                >
                  <a> -</a>
                </div>
                <div class="combo_num ar-number">{{ dataItems.Qty }}</div>
                <div
                  class="combo_icon"
                  @click="
                    storeAlternateFnbItems(
                      dataItems,
                      'add',
                      dataItems.fnbItemDataIndex,
                      dataItems.fnbItemDataItemsIndex
                    )
                  "
                >
                  <a> +</a>
                </div>
              </div>
            </div>

            <div class="" style="margin-top: 5px">
              <div
                class="fnb-amt ar-number"
                style="
                              white-space: nowrap;
                              margin-top: 12px;
                              width: auto;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              color: #000 !important;
                            "
              >
                {{ dataItems.Description }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//   import FoodMark from "@/components/UIElements/VegMark.vue";

export default {
  name: "AlternativeItems",
  components: {
    //   FoodMark,
  },
  props: {
    refId: {
      type: String,
      default: "alternate-itmes-modal",
    },
    title: {
      type: String,
      default: "Please Select Alternate Items",
    },
    isAlternateItemLoading: {
      type: Boolean,
      default: false,
    },
    AlternateItemsIds: {
      type: Array,
      default: [],
    },
    onClickItem: { type: Function },
    AllfnbItem: { type: Array, default: [] },
  },
  data() {
    return {
      userSelectedAlternateFnBItems: [],
    };
  },

  computed: {
    getAlternateItemsIds() {
      return this.AlternateItemsIds;
    },
    getAllFnbItemData() {
      return this.AllfnbItem;
    },
    getFilteredAlterNativeFnbItems() {
      return this.AllfnbItem.map((parent) => {
        const filteredItems = parent.items.filter((item) =>
          this.AlternateItemsIds.includes(item.Id)
        );
        if (filteredItems.length > 0) {
          return {
            ...parent,
            items: filteredItems,
          };
        }
        return null; // If no items match, return null
      }).filter(Boolean);
    },
  },
  beforeMount() {},
  methods: {
    storeAlternateFnbItems(
      foodItem,
      type,
      fnbItemDataIndex,
      fnbItemDataItemsIndex
    ) {
      //   console.log("index", index);
      let emitPayload = {
        foodItem,
        type,
        fnbItemDataIndex,
        fnbItemDataItemsIndex,
      };
      this.$emit("handleAlternativeItemChange", emitPayload);
      // this.$emit("alternativeSelectedItem", emitPayload);

      // if (type == "add") {
      //   let selecteditem = this.AllfnbItem[fnbItemDataIndex].items.filter(
      //     (x) => {
      //       return x.Id == foodItem.Id && foodItem.FnbDetail.is_combo == "N";
      //     }
      //   );
      //   if (selecteditem.length > 0) {
      //     if (selecteditem[0].Qty < 10) {
      //       this.AllfnbItem[fnbItemDataIndex].items[
      //         fnbItemDataItemsIndex
      //       ].Qty += 1;
      //       this.totalAmount = +parseFloat(
      //         parseFloat(this.totalAmount) + parseFloat(selecteditem[0].Amount)
      //       ).toFixed(4);
      //     }
      //   }
      // }

      // if (type == "sub") {
      //   let selecteditem = this.AllfnbItem[fnbItemDataIndex].items.filter(
      //     (x) => {
      //       return x.Id == foodItem.Id;
      //     }
      //   );
      //   if (selecteditem.length > 0 && selecteditem[0].Qty != 0) {
      //     this.AllfnbItem[fnbItemDataIndex].items[
      //       fnbItemDataItemsIndex
      //     ].Qty -= 1;

      //     this.totalAmount = +parseFloat(
      //       parseFloat(this.totalAmount) - parseFloat(selecteditem[0].Amount)
      //     ).toFixed(4);
      //     // console.log(selecteditem, "ki");
      //   }
      // }
      this.userSelectedAlternateFnBItems = [];
      this.AllfnbItem.map((category) => {
        if (category.items) {
          category.items.map((item) => {
            if (item.Qty != 0) {
              let obj = {
                Id: item.Id,
                Qty: item.Qty,
                ItemName: item.ItemName,
              };

              this.userSelectedAlternateFnBItems.push(obj);
              this.$emit(
                "isAlterNativeItemselected",
                this.userSelectedAlternateFnBItems
              );
            }
          });
        }
      });

      this.$forceUpdate();
    },

    close() {
      this.$bvModal.hide(this.refId);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/FnbPopup/AlternateItemModal.vue